/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { type ClientCompany } from 'walden-fast/types/user';

export interface ClientDropdownSignature {
  Args: {
    availableClients: ClientCompany[];
    selectedClientIds?: string[];
    onChange?: (selectedClientIds: string[]) => void;
  };
}

export default class ClientDropdownComponent extends Component<ClientDropdownSignature> {
  @tracked searchTerm = '';

  constructor(owner: unknown, args: ClientDropdownSignature['Args']) {
    super(owner, args);
  }

  get selectedClientIds() {
    return this.args.selectedClientIds || [];
  }

  get filteredClients() {
    let clients = this.args.availableClients;

    if (this.searchTerm.trim()) {
      const searchLower = this.searchTerm.toLowerCase();
      clients = clients.filter((client) =>
        client.displayName.toLowerCase().includes(searchLower),
      );
    }

    return clients;
  }

  get selectedClients() {
    return this.args.availableClients.filter((client) =>
      this.selectedClientIds.includes(client.id),
    );
  }

  isClientSelected = (clientId: string) => {
    return this.selectedClientIds.includes(clientId);
  };

  updateSearchTerm = (value: string) => {
    this.searchTerm = value;
  };

  @action
  toggleClient(client: ClientCompany) {
    const clientId = client.id;
    const isSelected = this.selectedClientIds.includes(clientId);
    const currentIds = this.selectedClientIds;

    let newIds: string[];
    if (isSelected) {
      newIds = currentIds.filter((id) => id !== clientId);
    } else {
      newIds = [...currentIds, clientId];
    }

    this.notifyChange(newIds);
  }

  @action
  clearAllClients() {
    this.notifyChange([]);
  }

  private notifyChange(selectedIds?: string[]) {
    if (this.args.onChange) {
      this.args.onChange(selectedIds || this.selectedClientIds);
    }
  }
}
